var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import * as React from "react";
import { observer } from "mobx-react";
import * as CMP from "../components";
import { JackpotWinningAnimationState } from "../state";
import { store } from "../../../data/store";
let JackpotWinningAnimationBlock = class JackpotWinningAnimationBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new JackpotWinningAnimationState(this.props.cms, this.props.dict, store)
        };
    }
    componentDidMount() {
        this.state.dataProvider.subscribe();
    }
    componentDidUpdate() {
        const dataProvider = this.state.dataProvider;
        if (dataProvider.jackpotWinAnimation.WonJackpot) {
            const { jackpotId, userID } = dataProvider.jackpotWinAnimation.WonJackpot.jackpotWinData.jackpot;
            dataProvider.store.notifyWinningAnimationShown(jackpotId, userID);
        }
    }
    render() {
        const dataProvider = this.state.dataProvider;
        const WonJackpot = dataProvider.jackpotWinAnimation.WonJackpot;
        return (React.createElement(React.Fragment, null, WonJackpot &&
            React.createElement(CMP.JackpotWinningAnimation, { dict: dataProvider.dict, eventName: WonJackpot.jackpotWinData.jackpot.externalName, amount: WonJackpot.jackpotWinData.jackpot.amount, currencyCode: dataProvider.currencySymbol, image: dataProvider.jackpotWinAnimation.backgroundImage, setWinning: dataProvider.setWinning })));
    }
};
JackpotWinningAnimationBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], JackpotWinningAnimationBlock);
export { JackpotWinningAnimationBlock };
//# sourceMappingURL=JackpotWinningAnimationBlock.js.map